import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { HandlePrivateRoute } from './handlePrivateRoute';
import { appRoutes } from './routes';
interface IProps {
    isAuthenticated: boolean;
}

export const PrivateRoute: React.FC<IProps> = ({ isAuthenticated }) => {
    const location = useLocation();

    return isAuthenticated ? (
        <>
            <Outlet />
            <HandlePrivateRoute />
        </>
    ) : (
        <Navigate to={`${appRoutes.AUTH.LOGIN}`} state={{ from: location }} replace />
    );
};
